export default __webpack_public_path__ + "static/media/Me.0e54abb9.svg";